import { render, staticRenderFns } from "./ProjectFeed.vue?vue&type=template&id=6be52f6f&"
import script from "./ProjectFeed.vue?vue&type=script&lang=js&"
export * from "./ProjectFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports